import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// 创建 axios 实例
const api = axios.create({
  baseURL: API_BASE,
});

// 添加请求拦截器以包含 token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 访客统计（需登录）
export const visitsAPI = {
  get: (days = 30) => api.get(`/visits?days=${days}`),
};

// About API
export const aboutAPI = {
  get: () => api.get('/about'),
  update: (data) => api.put('/about', data),
};

// Skills API
export const skillsAPI = {
  get: () => api.get('/skills'),
  update: (data) => api.put('/skills', data),
};

// Projects API
export const projectsAPI = {
  getAll: () => api.get('/projects'),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  delete: (id) => api.delete(`/projects/${id}`),
};

// Blog API
export const blogAPI = {
  getAll: () => api.get('/blog'),
  create: (data) => api.post('/blog', data),
  update: (id, data) => api.put(`/blog/${id}`, data),
  delete: (id) => api.delete(`/blog/${id}`),
};

// Contact API
export const contactAPI = {
  submit: (data) => api.post('/contacts', data),
  getAll: () => api.get('/contacts'),
};

// Gallery API
export const galleryAPI = {
  getAll: () => api.get('/gallery'),
  add: (data) => api.post('/gallery', data),
  delete: (id) => api.delete(`/gallery/${id}`),
};

// Todo API
export const todoAPI = {
  getAll: () => api.get('/todos'),
  create: (data) => api.post('/todos', data),
  update: (id, data) => api.put(`/todos/${id}`, data),
  delete: (id) => api.delete(`/todos/${id}`),
};

// Notion Projects API
export const notionAPI = {
  getAll: () => api.get('/notion-projects'),
  createProject: (data) => api.post('/notion-projects', data),
  deleteProject: (id) => api.delete(`/notion-projects/${id}`),
  addTask: (projectId, data) => api.post(`/notion-projects/${projectId}/tasks`, data),
  updateTask: (projectId, taskId, data) => api.put(`/notion-projects/${projectId}/tasks/${taskId}`, data),
  deleteTask: (projectId, taskId) => api.delete(`/notion-projects/${projectId}/tasks/${taskId}`),
};

// Auth API
export const authAPI = {
  login: (password) => api.post('/auth/login', { password }),
};
